import { render, staticRenderFns } from "./show_check_images.vue?vue&type=template&id=37c05457&"
import script from "./show_check_images.vue?vue&type=script&lang=js&"
export * from "./show_check_images.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports